module.exports = __webpack_public_path__ + "static/assets/img/j_molina.345166e3.jpeg";